import { AxiosError } from 'axios'

/**
 * The three outcomes a caller has to render differently.
 *
 * The 401/403 split is a contract with the backend, not an implementation detail: 401 means the
 * token was rejected and re-authenticating may fix it, 403 means the caller is authenticated and
 * still not entitled to this plan. Re-authenticating on a 403 would loop forever.
 */
export const ApiErrorKind = {
  Unauthenticated: 'unauthenticated',
  Forbidden: 'forbidden',
  Unknown: 'unknown',
} as const

export type ApiErrorKind = (typeof ApiErrorKind)[keyof typeof ApiErrorKind]

export const apiErrorKindOf = (error: unknown): ApiErrorKind => {
  switch ((error as AxiosError)?.response?.status) {
    case 401:
      return ApiErrorKind.Unauthenticated
    case 403:
      return ApiErrorKind.Forbidden
    default:
      return ApiErrorKind.Unknown
  }
}
